import { render } from "./MessageError.vue?vue&type=template&id=a2960578"
import script from "./MessageError.vue?vue&type=script&lang=js"
export * from "./MessageError.vue?vue&type=script&lang=js"
script.render = render

export default script